import type { Module } from 'vuex';
import { actions } from './editor-view-input.actions';
import { mutations } from './editor-view-input.mutations';
import { getDefaultState } from './editor-view-input.constants';
import type { EditorViewInputState } from './editor-view-input.types';
import type { EditorViewState } from './editor-view.types';

export const editorViewInput: Module<EditorViewInputState, EditorViewState> = {
  state: getDefaultState(),
  actions,
  mutations,
  namespaced: true,
};

export const editorViewInputState = editorViewInput.state as EditorViewInputState;
